"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M20 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2c0 .2281.0382.4473.1085.6516l-2.4569 2.457A1.9979 1.9979 0 0015 7c-.4229 0-.8152.1313-1.1382.3553l-2.8744-1.5808C10.8754 4.776 10.0283 4 9 4c-1.1046 0-2 .8954-2 2 0 .1242.0113.2457.033.3635L4.718 8.1328A1.995 1.995 0 004 8c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2c0-.1128-.0093-.2233-.0273-.331l2.3416-1.7897A1.996 1.996 0 009 8a1.991 1.991 0 001.1955-.3965l2.81 1.5454C13.0816 10.1839 13.9455 11 15 11c1.1046 0 2-.8954 2-2 0-.1286-.0121-.2543-.0353-.3762l2.6591-2.6591C19.7457 5.9879 19.8714 6 20 6zm2 8c0 1.1046-.8954 2-2 2a2.0103 2.0103 0 01-.3762-.0353l-2.6591 2.6591c.0232.1219.0353.2476.0353.3762 0 1.1046-.8954 2-2 2-1.0545 0-1.9184-.8161-1.9945-1.8511l-2.81-1.5454A1.9913 1.9913 0 019 18a1.9953 1.9953 0 01-.6857-.1207L5.9727 19.669c.018.1076.0273.2182.0273.331 0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2c.2531 0 .4952.047.7181.1328l2.3149-1.7693A2.0106 2.0106 0 017 16c0-1.1046.8954-2 2-2 1.0283 0 1.8754.7761 1.9874 1.7745l2.8744 1.5808A1.9906 1.9906 0 0115 17c.2281 0 .4473.0382.6516.1085l2.4569-2.4569A1.999 1.999 0 0118 14c0-1.1046.8954-2 2-2s2 .8954 2 2z",
  clipRule: "evenodd"
})), 'LineChartIcon');
/* eslint-enable */


exports["default"] = _default;